import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ApContentModule } from '@ap/content';
import { ApButtonComponent } from '@ap/button';
import { ApIllustrationComponent } from '@ap/illustration';

import { LogoutPageComponent } from './logout-page.component';

/**
 * @ngdoc module
 * @name LogoutPageModule
 */
@NgModule({
    imports: [ApButtonComponent, CommonModule, ApContentModule, ApIllustrationComponent],
    declarations: [LogoutPageComponent],
    exports: [LogoutPageComponent]
})
export class LogoutPageModule {}
